import _ from 'lodash';
import { BaseController } from '../../common/base/controller';

export class CustomerEntryController extends BaseController {
  constructor(controllerService, receivingCreateRequestStateName) {
    'ngInject';
    super({ controllerService, receivingCreateRequestStateName });
  }

  $onInit() {
    if (!this.isStateAvailable) {
      this.notFound();
    }

    const { numSteps, numDetailSteps, showDetailSteps, showInfoBox, footer } =
      this.config.ui.customerEntry;

    this.steps = _.times(numSteps, String);
    this.detailSteps = _.times(numDetailSteps, String);
    this.showDetailSteps = showDetailSteps;
    this.showInfoBox = showInfoBox;
    this.errorMessage = {
      required: 'customerEntry.intro.confirmCondition.error',
    };
    this.footer = footer;
    this.customLinks = footer.customLinks || null;

    // remove customLinks because it would render an additional link with invalid url
    delete this.footer.customLinks;
  }

  startAccountswitch() {
    this.form.$setSubmitted(true);
    const isInvalid =
      this.customLinks &&
      this.form &&
      this.form.$invalid &&
      !this.cofirmCondition;
    if (isInvalid) {
      return;
    }

    this.authService
      .authenticateCustomerEntry()
      .then(() => {
        this.go(this.receivingCreateRequestStateName);
      })
      .busy(this, 'started');
  }
}
